import { ROLES } from './Role';
import HANA_LOGO from 'src/assets/hanaHeroPersonaImage.webp';
import GITHUB_LOGO from 'src/assets/github-mark.png';
import TRELLO_LOGO from 'src/assets/trello.png';
import JIRA_LOGO from 'src/assets/jira.webp';
import ASANA_LOGO from 'src/assets/asana.png';

export const DEFAULT_CONNECTOR_LOGO = {
  imageUrl: HANA_LOGO,
  imageAltText: 'Connector Logo',
};

export enum CONNECTOR_NAME {
  CONFLUENCE = 'CONFLUENCE',
  GOOGLE_CHAT = 'GOOGLE_CHAT',
  ZAPIER = 'ZAPIER',
  JIRA = 'JIRA',
  TRELLO = 'TRELLO',
  NOTION = 'NOTION',
  GITHUB = 'GITHUB',
  EXPOSE_API = 'EXPOSE_API',
  ASANA = 'ASANA',
}

export enum CONNECTOR_VARIANT {
  STANDARD = 'STANDARD',
  MCP = 'MCP',
}

export enum MCP_AUTH_TYPE {
  BEARER = 'BEARER',
  OAUTH2 = 'OAUTH2',
}

export enum MCP_OAUTH_PROVIDER {
  ASANA = 'ASANA',
  CUSTOM = 'CUSTOM',
}

export const CONFLUENCE_MAX_TOKEN_LENGTH = 256; // characters

export const CONNECTOR_LOGOS: Record<
  CONNECTOR_NAME,
  {
    imageUrl: string;
    imageAltText: string;
  }
> = {
  CONFLUENCE: {
    imageUrl:
      'https://play-lh.googleusercontent.com/ioJTF4OMDt2-x3Mnz_LEIHpoGjig_g7nfECiKsaFlvasBeo0myuKqnc6XHoItyL3OSE=w240-h480-rw',
    imageAltText: 'Confluence Logo',
  },
  GOOGLE_CHAT: {
    imageUrl:
      'https://mailmeteor.com/logos/assets/PNG/Google_Chat_Logo_256px.png',
    imageAltText: 'Google Chat Logo',
  },
  ZAPIER: {
    imageUrl:
      'https://images.ctfassets.net/lzny33ho1g45/7sYLMymQDinPKZQS77P4BX/9545150792946dbb3c3d48f0fd18b55a/Zapier_logo.jpg?w=1520&fm=avif&q=31&fit=thumb&h=760',
    imageAltText: 'Zapier Logo',
  },
  NOTION: {
    imageUrl:
      'https://upload.wikimedia.org/wikipedia/commons/e/e9/Notion-logo.svg',
    imageAltText: 'Notion Logo',
  },
  JIRA: {
    imageUrl: JIRA_LOGO,
    imageAltText: 'Jira Logo',
  },
  TRELLO: {
    imageUrl: TRELLO_LOGO,
    imageAltText: 'Trello Logo',
  },
  GITHUB: {
    imageUrl: GITHUB_LOGO,
    imageAltText: 'GitHub Logo',
  },
  EXPOSE_API: {
    imageUrl: HANA_LOGO,
    imageAltText: 'Hana API Logo',
  },
  ASANA: {
    imageUrl: ASANA_LOGO,
    imageAltText: 'Asana Logo',
  },
};

export const CONNECTOR_ALLOWED_ROLES: Array<keyof typeof ROLES> = [
  ROLES.ADMIN,
  ROLES.SUPER_ADMIN,
  ROLES.DOMAIN_OWNER,
];

/**
 * Leave empty for accepting all domains, added specific values to restrict to those domains only
 * TODO - Make sure backend restrictions are in place too for security
 */
export const CONNECTOR_WHITELISTED_DOMAINS: Record<
  CONNECTOR_NAME,
  Array<string>
> = {
  CONFLUENCE: [],
  GITHUB: [],
  GOOGLE_CHAT: [],
  JIRA: [],
  NOTION: [],
  TRELLO: [],
  ZAPIER: [],
  EXPOSE_API: [],
  ASANA: ['hanabitech.com'],
};

// Deprecated connectors remain in the codebase for backward compatibility,
// but should not be shown in the dashboard UI.
export const DEPRECATED_CONNECTORS: ReadonlyArray<CONNECTOR_NAME> = [
  CONNECTOR_NAME.CONFLUENCE,
  CONNECTOR_NAME.JIRA,
  CONNECTOR_NAME.ASANA,
  // Zapier is no longer an end-user dashboard flow. Keep the enum value so
  // backend payloads still deserialize, but hide it from connector discovery.
  CONNECTOR_NAME.ZAPIER,
  // API credentials have a dedicated legacy navigation/page, not a revamp
  // Action/answer Source connection. Keep them out of source discovery cards.
  CONNECTOR_NAME.EXPOSE_API,
];

export const CONNECTOR_ACCOUNT_SEARCH_PLACEHOLDER = 'Search accounts';

export const CONNECTOR_CARD_SKELETON_COUNT = 6;
